import { useCountry } from './useCountry';
import { useSelectedCountryCodes } from './useSelectedCountryCodes';

/**
 * Query to get country data for the selected country.
 * Assumes that there is exactly one country selected.
 */
export function useSelectedCountry() {
  const countryCodes = useSelectedCountryCodes();

  if (countryCodes.length !== 1) {
    throw new Error('This hook only works with one selected country');
  }

  return useCountry(countryCodes[0]);
}
